import * as Icon from "assets/svg";

export const AdminSideBarMenuData = [
  {
    id: "1",
    title: "Overview",
    icon: <img src={Icon.OverviewIcon} alt="" />,
    path: "/",
  },
  {
    id: "2",
    title: "Tickets",
    icon: <img src={Icon.Tickets} alt="" />,
    path: "/tickets",
  },
  {
    id: "3",
    title: "Customers",
    icon: <img src={Icon.Customers} alt="" />,
    path: "/customers",
  },
  // {
  //   id: "4",
  //   title: "Accounting",
  //   icon: <img src={Icon.Accounting} alt="" />,
  //   path: "/accounting",
  // },
  {
    id: "4",
    title: "Reports",
    icon: <img src={Icon.Reports} alt="" />,
    path: "/reporting",
  },
  {
    id: "5",
    title: "Chats",
    icon: <img src={Icon.Chat} alt="" />,
    path: "/chats",
  },
  {
    id: "6",
    title: "Feedback",
    icon: <img src={Icon.Feedbacks} alt="" />,
    path: "/feedbacks",
  },
  {
    id: "7",
    title: "Settings",
    icon: <img src={Icon.SettingIcon} alt="Setting Icon" />,
    path: "/settings",
  },
];
